document.addEventListener('turboujs:load', (_event) => {
  document.querySelectorAll('.calendar-header__form form select').forEach((element, i) => {
    element.addEventListener('change', selectChanged)
  });
})

function selectChanged(event) {
  let form = this.closest('form')
  form.submit()
}
